import React, { useEffect, useState } from "react";
import "./Likes.scss";
import { Button, Card, Table } from "react-bootstrap";
import { useBackButton } from "../../hooks/useBackButton";
import Header from "../../components/Header";
import SubHeader from "../../components/SubHeader";
import { useNavigate } from "react-router-dom";
import TabsHeader from "../../components/TabsHeader";
import TabsBody from "../../components/TabsBody";
import { useLocalDB } from '../../contexts/LocalDBContext';
import LikeButton from "../../components/LikeButton";

const Likes = () => {
  const navigate = useNavigate();
  useBackButton("/", false, false);

  const [mixedItems, setMixedItems] = useState([]);
  
    const { getArticlesByStudioId, getPortfoliosByStudioId, getAllStudios } = useLocalDB();
  
    useEffect(() => {
      const loadContent = async () => {
        const studios = await getAllStudios();
        const allItems = [];
  
        for (const studio of studios) {
          const articles = await getArticlesByStudioId(studio.id);
          const portfolios = await getPortfoliosByStudioId(studio.id);
          allItems.push(...articles, ...portfolios);
        }
  
        const shuffled = allItems.sort(() => Math.random() - 0.5);
        setMixedItems(shuffled);
      };
  
      loadContent();
    }, [getArticlesByStudioId, getPortfoliosByStudioId, getAllStudios]);

  return (
    <>
      <Header></Header>
      <SubHeader></SubHeader>
      <div className="row main-page">
        <div className="col col-0 cancel col-md-3">
          <div className="return-btn" onClick={() => {navigate("/")}}>
            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M0 20C0 16.2828 0 14.4241 0.307436 12.8786C1.56994 6.53151 6.53151 1.56994 12.8786 0.307436C14.4241 0 16.2828 0 20 0C23.7172 0 25.5759 0 27.1214 0.307436C33.4685 1.56994 38.4301 6.53151 39.6926 12.8786C40 14.4241 40 16.2828 40 20C40 23.7172 40 25.5759 39.6926 27.1214C38.4301 33.4685 33.4685 38.4301 27.1214 39.6926C25.5759 40 23.7172 40 20 40C16.2828 40 14.4241 40 12.8786 39.6926C6.53151 38.4301 1.56994 33.4685 0.307436 27.1214C0 25.5759 0 23.7172 0 20Z"
                fill="white" />
              <path fillRule="evenodd" clipRule="evenodd"
                d="M23.0893 14.4108C22.7638 14.0854 22.2362 14.0854 21.9108 14.4108L16.9108 19.4108C16.7545 19.5671 16.6667 19.7791 16.6667 20.0001C16.6667 20.2211 16.7545 20.4331 16.9108 20.5893L21.9108 25.5893C22.2362 25.9148 22.7638 25.9148 23.0893 25.5893C23.4147 25.2639 23.4147 24.7363 23.0893 24.4108L18.6785 20.0001L23.0893 15.5893C23.4147 15.2639 23.4147 14.7363 23.0893 14.4108Z"
                fill="#191A21" />
            </svg>
            Назад
          </div>
        </div>
        <div className="col col-12 col-md-9">
            <div className="card">
              <div className="row">
                <div className="col col-12 elements-container">
                  <div className="element-col">
                    <h1>Избранное</h1>
                  </div>
                </div>
                <div className="col col-12 elements-container">
                  {mixedItems.map((item) => (
                    <div
                      key={item.id}
                      className="element-col"
                    >
                      <img
                        className="rounded mx-auto img-fluid d-block"
                        src={`/images/${item.image1}`}
                        alt=""
                        onClick={() => navigate(`/post/${item.id}`)}
                      />
                      {item.text && (
                        <p className="like-post">{item.text}</p>
                      )}
                      <LikeButton initialLikes={item.likes}></LikeButton>
                    </div>
                  ))}
                  </div>
              </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Likes;
